import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useReplaceBetslipConfirmation } from '@/hooks/use-replace-betslip-confirmation';
import { triggerHapticFeedback } from '@/utils/haptic-feedback';

import { BetslipPick } from '../types';
import { isPrebuiltLineupInBetslip } from '../utils/betslip-utils';
import { useBetslipNavigation } from './use-betslip-navigation';
import { BetslipRefferer, useBetslipStore } from './use-betslip-store';

export const useAddLineupToBetslip = () => {
    const betslip = useBetslipStore(state => state.betslip);
    const replacePicks = useBetslipStore(state => state.actions.replacePicks);
    const { showReplaceBetslipConfirmation } = useReplaceBetslipConfirmation();
    const { t } = useTranslation('lineup_update_modal');
    const { navigateToPickslip } = useBetslipNavigation();

    const addLineup = useCallback(
        (picks: BetslipPick[], refferer?: BetslipRefferer) => {
            const applyLineup = () => {
                replacePicks(picks, refferer);
                triggerHapticFeedback();
                navigateToPickslip();
            };
            if (betslip.length === 0) {
                applyLineup();
                return;
            }
            if (isPrebuiltLineupInBetslip(betslip, picks)) {
                return;
            }
            showReplaceBetslipConfirmation({
                title: t('replace_lineup_title'),
                description: t('replace_lineup_info'),
                replaceLabel: t('replace_lineup'),
                keepLabel: t('keep_lineup'),
                onReplace: applyLineup,
            });
        },
        [betslip, showReplaceBetslipConfirmation, navigateToPickslip, replacePicks, t]
    );

    return { addLineup };
};
